// extracted by mini-css-extract-plugin
module.exports = {"pintxo-pagination-dots":"PaginationDots_pintxo-pagination-dots__x3Ear","pintxo-pagination-dots__container":"PaginationDots_pintxo-pagination-dots__container__nXH7U"};